import axios from "axios";

const axiosWithHandling = async (url, options = {}) => {
    try {
        const { method = "GET", ...restOptions} = options; // default to get is no options provided
        const response = await axios({ url, method, ...restOptions});

        return response.data;
    } catch (error) {
        if (error.response) {
            const statusCode = error.response.status
            const statusText = error.response.statusText
            const data = error.response.data
            console.error(`Returned error: ${statusCode}`, data)
            // throw new Error(`Error ${statusCode}: ${statusText}`, {cause : data})   
            throw new Error(`${statusCode}`)
        } else if (error.request) {
            // console.error(`Network error:`, error.request);
            throw new Error(`Network error: No response recieved`)
        } else {
            // console.error(`error:`, error.message)
            throw new Error(error.message)
        }
    }

}

export default axiosWithHandling;